import { gql } from '@apollo/client'

export const Query = gql`
  query EditShift($companyId: ID!, $filters: ShiftFilters) {
    shifts(companyId: $companyId, filters: $filters, first: 1) {
      nodes {
        id
        user { id name }
        start
        finish
        rateCents
        shiftRole { id }
        event { id currency description }
      }
    }
  }
`
